<script lang="ts">
    interface Props {
        checked: boolean;
        disabled?: boolean;
        onchange?: () => void;
    }

    let { checked = $bindable(), disabled = false, onchange }: Props = $props();
</script>

<button
    type="button"
    role="switch"
    aria-checked={checked}
    {disabled}
    onclick={() => { if (!disabled) { checked = !checked; onchange?.(); } }}
    class="relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-cyan-500 focus:ring-offset-2 {checked ? 'bg-cyan-600' : 'bg-gray-700'} {disabled ? 'opacity-50 cursor-not-allowed' : ''}"
>
    <span
        aria-hidden="true"
        class="pointer-events-none inline-block size-5 rounded-full bg-white shadow ring-0 transition-transform duration-200 ease-in-out {checked ? 'translate-x-5' : 'translate-x-0'}"
    ></span>
</button>
